const catBreeds = [
    { value: 'unknown', label: { en: 'Unknown', es: 'Desconocido' } },
    { value: 'abyssinian', label: { en: 'Abyssinian', es: 'Abisinio' } },
    { value: 'american_bobtail', label: { en: 'American Bobtail', es: 'Bobtail Americano' } },
    { value: 'american_curl', label: { en: 'American Curl', es: 'Curl Americano' } },
    { value: 'american_shorthair', label: { en: 'American Shorthair', es: 'Pelo Corto Americano' } },
    { value: 'american_wirehair', label: { en: 'American Wirehair', es: 'Pelo Duro Americano' } },
    { value: 'balinese', label: { en: 'Balinese', es: 'Balinés' } },
    { value: 'bengal', label: { en: 'Bengal', es: 'Bengala' } },
    { value: 'birman', label: { en: 'Birman', es: 'Birmano' } },
    { value: 'bombay', label: { en: 'Bombay', es: 'Bombay' } },
    { value: 'british_shorthair', label: { en: 'British Shorthair', es: 'Pelo Corto Británico' } },
    { value: 'burmese', label: { en: 'Burmese', es: 'Burmés' } },
    { value: 'burmilla', label: { en: 'Burmilla', es: 'Burmilla' } },
    { value: 'chartreux', label: { en: 'Chartreux', es: 'Cartujo' } },
    { value: 'colorpoint_shorthair', label: { en: 'Colorpoint Shorthair', es: 'Pelo Corto Colorpoint' } },
    { value: 'cornish_rex', label: { en: 'Cornish Rex', es: 'Cornish Rex' } },
    { value: 'devon_rex', label: { en: 'Devon Rex', es: 'Devon Rex' } },
    { value: 'egyptian_mau', label: { en: 'Egyptian Mau', es: 'Mau Egipcio' } },
    { value: 'exotic', label: { en: 'Exotic', es: 'Exótico' } },
    { value: 'havana_brown', label: { en: 'Havana Brown', es: 'Havana Brown' } },
    { value: 'japanese_bobtail', label: { en: 'Japanese Bobtail', es: 'Bobtail Japonés' } },
    { value: 'khao_manee', label: { en: 'Khao Manee', es: 'Khao Manee' } },
    { value: 'korat', label: { en: 'Korat', es: 'Korat' } },
    { value: 'laperm', label: { en: 'LaPerm', es: 'LaPerm' } },
    { value: 'lykol', label: { en: 'Lykoi', es: 'Lykoi' } },
    { value: 'maine_coon', label: { en: 'Maine Coon', es: 'Maine Coon' } },
    { value: 'manx', label: { en: 'Manx', es: 'Manx' } },
    { value: 'nebelung', label: { en: 'Nebelung', es: 'Nebelung' } },
    { value: 'norwegian_forest_cat', label: { en: 'Norwegian Forest Cat', es: 'Bosque de Noruega' } },
    { value: 'ocicat', label: { en: 'Ocicat', es: 'Ocicat' } },
    { value: 'oriental', label: { en: 'Oriental', es: 'Oriental' } },
    { value: 'persian', label: { en: 'Persian', es: 'Persa' } },
    { value: 'pixiebob', label: { en: 'Pixiebob', es: 'Pixiebob' } },
    { value: 'ragamuffin', label: { en: 'Ragamuffin', es: 'Ragamuffin' } },
    { value: 'ragdoll', label: { en: 'Ragdoll', es: 'Ragdoll' } },
    { value: 'russian_blue', label: { en: 'Russian Blue', es: 'Azul Ruso' } },
    { value: 'scottish_fold', label: { en: 'Scottish Fold', es: 'Fold Escocés' } },
    { value: 'selkirk_rex', label: { en: 'Selkirk Rex', es: 'Selkirk Rex' } },
    { value: 'siamese', label: { en: 'Siamese', es: 'Siamés' } },
    { value: 'siberian', label: { en: 'Siberian', es: 'Siberiano' } },
    { value: 'singapura', label: { en: 'Singapura', es: 'Singapura' } },
    { value: 'somali', label: { en: 'Somali', es: 'Somalí' } },
    { value: 'sphynx', label: { en: 'Sphynx', es: 'Esfinge' } },
    { value: 'tonkinese', label: { en: 'Tonkinese', es: 'Tonquinés' } },
    { value: 'turkish_angora', label: { en: 'Turkish Angora', es: 'Angora Turco' } },
    { value: 'turkish_van', label: { en: 'Turkish Van', es: 'Van Turco' } },
];

export default catBreeds;